import React, { useState, useEffect } from "react";
import { FormInput, FormSelect, Row, Col, Button } from "shards-react";
import baseUrl from "config/baseUrl";
import useToken from "shared/hook/useToken";
import styled from "styled-components";

const Table32 = (props) => {
  const { token } = useToken();
  const [loading, setLoading] = useState(false);
  const [onEditCurrent, setOnEditCurrent] = useState(
    props.type === "edit" ? false : true
  );
  const [importPath, setImportPath] = useState(null);
  const [PowerbiData, setPowerbiData] = useState(null);
  const [previousData, setPreviousData] = useState(null);
  const [statusList, setStatus] = useState(null);
  const [academyList, setAcademy] = useState(null);
  const [academytypeList, setAcademytype] = useState(null);
  const [fieldList, setField] = useState(null);
  const [subjectList, setSubject] = useState(null);
  const [subjecttypeList, setSubjecttype] = useState(null);
  const [regiontypeList, setRegiontype] = useState(null);
  const [masterprovince, setMasterprovince] = useState(null);

  const axios = require("axios").default;
  //4 สร้างข้อมูลเพื่อส่งไปอนุมัติ
  const onCeateTable = () => {
    const obj = [];
    PowerbiData.map((item, index) => {
      const data = { ...item };
      data.yearId = props.yearId;
      delete data.id;
      delete data.createDate;
      delete data.lastUpdate;
      delete data.tableHeadId;
      delete data.id;
      obj.push(data);
    });
    const filter = obj.filter((item) => item.fillValue === "");
    console.log("@PowerbiData", filter);
    if (filter.length > 0) {
      alert("กรุณากรอกข้อมูลให้ครบถ้วน");
      return false;
    }
    props.onCeateTable(obj);
  };

  const getCurrentData = () => {
    setLoading(true);
    let data = JSON.stringify({
      params: {
        indicatorsDatasetSettingId: props.indicatorsDatasetSettingId,
        tableTabSettingId: props.tableTabSettingId || null,
        tableHeadId: props.listheadId || null,
        yearNo: props.newHeadId ?  null  : Number(props.yearNo)
      },
      show: 1,
      page: 1,
      orderBy: "id",
      orderType: "desc",
    });

    var configData = {
      method: "post",
      url: `${baseUrl}/v1/setting-table/listhead`,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      data: data,
    };
    axios(configData)
      .then(function(response) {
        
        if (response.data.data.length > 0) {
          setImportPath(response.data.data[0].importPath);
          if(response.data.data[0].list.length == 0){
            getNewData();
          }
          else{
            const dataView = response.data.data[0].list.map((item) => {
              let data = { ...item };
              if (props.type === "new" && props.newHeadId){
                if(response.data.data[0].yearId !=  props.yearId){
                data.fillValue = "";
                data.growth = "";}
              }
              return data;
            });setLoading(false);
            setPowerbiData(dataView);
          }
        } else {setLoading(false);
          setPowerbiData(null);
        }
      })
      .catch(function(error) {setLoading(false);
        console.log(
          `v1/setting-table/listhead ${props.indicatorsDatasetSettingId}`,
          error
        );
      });
  };

  const getNewData = () => {
    setLoading(true);
    let data = JSON.stringify({
      params: {
        indicatorsDatasetSettingId: props.indicatorsDatasetSettingId,
        tableTabSettingId: props.tableTabSettingId
      },
      show: 1,
      page: 1,
      orderBy: "id",
      orderType: "desc",
    });

    var configData = {
      method: "post",
      url: `${baseUrl}/v1/setting-table/listhead`,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      data: data,
    };
    axios(configData)
      .then(function(response) {
        setLoading(false);
        if (response.data.data.length > 0) {
          const dataView = response.data.data[0].list.map((item) => {
            let data = { ...item };
              data.fillValue = "";
              data.growth = "";
            return data;
          });
          setPowerbiData(dataView);
        } else {
          setPowerbiData(null);
        }
      })
      .catch(function(error) {setLoading(false);
        console.log(
          `v1/setting-table/listhead ${props.indicatorsDatasetSettingId}`,
          error
        );
      });
  };

  const getPreviousData = () => {
    let data = JSON.stringify({
      params: {
        indicatorsDatasetSettingId: props.indicatorsDatasetSettingId,
        tableTabSettingId: props.tableTabSettingId,
        status: 1,
        yearNo: Number(props.yearNo) - 1,
      },
      show: 1,
      page: 1,
      orderBy: "id",
      orderType: "desc",
    });

    var configData = {
      method: "post",
      url: `${baseUrl}/v1/setting-table/listhead`,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      data: data,
    };
    axios(configData)
      .then(function(response) {
        console.log(`getPreviousData ${props.yearsName}`, response.data);
        if (response.data.data.length > 0) {
          const viewData = response.data.data[0].list.map((item, key) => {
            return {
              typeId: item.typeId,
              typeName: item.typeName,
              unitId: item.unitId,
              unitName: item.unitName,
              fillValue: item.fillValue,
            };
          });
          setPreviousData(viewData);
          console.log("setPreviousData", previousData);
        } else {
          setPreviousData(null);
        }
      })
      .catch(function(error) {
        console.log(
          `/v1/setting-table/listhead/yearNo=${props.yearNo}`,
          error
        );
      });
  };

  const getStatus = () => {
    var config = {
      method: "get",
      url: `${baseUrl}/v1/table32/table32status`,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    };
    axios(config)
      .then(function(response) {
        setStatus(response.data);
      })
      .catch(function(error) {
        console.log("/v1/table32/table32status", error);
      });
  };

  const getAcademy = () => {
    var config = {
      method: "get",
      url: `${baseUrl}/v1/table32/table32academy`,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    };
    axios(config)
      .then(function(response) {
        setAcademy(response.data);
      })
      .catch(function(error) {
        console.log("/v1/table32/table32academy", error);
      });
  };

  const getAcademytype = () => {
    var config = {
      method: "get",
      url: `${baseUrl}/v1/table32/table32academytype`,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    };
    axios(config)
      .then(function(response) {
        setAcademytype(response.data);
      })
      .catch(function(error) {
        console.log("/v1/table32/table32academytype", error);
      });
  };

  const getField = () => {
    var config = {
      method: "get",
      url: `${baseUrl}/v1/table32/table32field`,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    };
    axios(config)
      .then(function(response) {
        setField(response.data);
      })
      .catch(function(error) {
        console.log("/v1/table32/table32field", error);
      });
  };

  const getSubject = () => {
    var config = {
      method: "get",
      url: `${baseUrl}/v1/table32/table32subject`,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    };
    axios(config)
      .then(function(response) {
        setSubject(response.data);
      })
      .catch(function(error) {
        console.log("/v1/table32/table32subject", error);
      });
  };

  const getSubjecttype = () => {
    var config = {
      method: "get",
      url: `${baseUrl}/v1/table32/table32subjecttype`,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    };
    axios(config)
      .then(function(response) {
        setSubjecttype(response.data);
      })
      .catch(function(error) {
        console.log("/v1/table32/table32subjecttype", error);
      });
  };

  const getRegiontype = () => {
    var config = {
      method: "get",
      url: `${baseUrl}/v1/table32/table32regiontype`,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    };
    axios(config)
      .then(function(response) {
        setRegiontype(response.data);
      })
      .catch(function(error) {
        console.log("/v1/table32/table32regiontype", error);
      });
  };



  const getMasterprovince = () => {
    var config = {
      method: "get",
      url: `${baseUrl}/v1/setting-table/masterprovince`,
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    };
    axios(config)
      .then(function(response) {
        setMasterprovince(response.data);
      })
      .catch(function(error) {
        console.log("/v1/setting-table/masterprovince", error);
      });
  };

  useEffect(() => {
    getStatus();
    getAcademy();
    getAcademytype();
    getField();
    getSubject();
    getSubjecttype();
    getRegiontype();
    getMasterprovince();
    getCurrentData();
  }, []);
  
  useEffect(() => {
    getCurrentData();
  }, [props.yearId]);

  const onAddRowTable = () => {
    let datas = [...PowerbiData];
    const data = {...datas[0]};
    data.fillValue = "";
    data.growth = "";
    setPowerbiData(datas.concat([data]));
  };

  const onSetdataCost = (index, value) => {
    const newTodos = [...PowerbiData];
    newTodos[index].fillValue = value;
    setPowerbiData(newTodos);
  };

  const onSetdata = (index, dataName, value) => {
    const newTodos = [...PowerbiData];
    newTodos[index][dataName] = value;
    setPowerbiData(newTodos);
  };

  const calRatio = (index, value) => {
    if (previousData == null || previousData[index] == undefined) {
      return Number(value).toFixed(2);
    } else {
      return ((Number(value) / previousData[index].value) * 100).toFixed(8);
    }
  };

  const calGrowth = (index, value) => {
    if (previousData == null || previousData[index] == undefined) {
      return Number(value).toFixed(2);
    } else {
      return (
        ((Number(value) - previousData[index].value) /
          previousData[index].value) *
        100
      ).toFixed(8);
    }
  };

  return (
    <Row>
      {props.tableTabSettingId == 64 && (
        <>
          <Col md="12" style={{ padding: "15px" }}>
            <h5>
              ข้อมูลชุดนี้เป็น Data Master หากต้องการเพิ่มกรุณาเพิ่มที่หน้า
              Upload file
            </h5>
          </Col>
          <Col
            md="12"
            style={{
              overflowX: "auto",
              display: "block",
            }}
          >
            <table className="table mb-0">
              <thead className="thead-dark">
                <tr>
                  <th scope="col">NO</th>
                  <th scope="col">Academy_Name </th>
                  <th scope="col">Province_TH </th>
                  <th scope="col">Academy_Type</th>
                  <th scope="col">Latitude</th>
                  <th scope="col">Longitude</th>
                </tr>
              </thead>
              {loading ? (
              <tbody className="table-middle">
                <tr>
                  <td colSpan={6}> Loading... </td>
                </tr>
              </tbody>
            ) : academyList != null && academyList.length > 0 ? (
              <tbody className="table-middle">
                {academyList.map((item, index) => (
                    <tr>
                      <td>{index + 1}</td>
                      <td>{item.academyName}</td>
                      <td>
                        <FormSelect
                          placeholder="- เลือก -"
                          value={item.provinceId}
                          disabled
                          onChange={(e) => {
                            onSetdata(index, "provinceId", e.target.value);
                          }}
                        >
                          <option value={null}>  กรุณาเลือกจังหวัด </option>
                          {masterprovince != null &&
                            masterprovince.length > 0 &&
                            masterprovince.map((item) => {
                              return (
                                <option value={item.provinceId}>
                                  {item.provinceName}
                                </option>
                              );
                            })}
                        </FormSelect>
                      </td>
                      <td>
                        <FormSelect
                          placeholder="- เลือก -"
                          value={item.academyTypeId}
                          disabled
                          onChange={(e) => {
                            onSetdata(index, "academyTypeId", e.target.value);
                          }}
                        >
                          <option value={null}>  กรุณาเลือกจังหวัด </option>
                          {academytypeList != null &&
                            academytypeList.length > 0 &&
                            academytypeList.map((item) => {
                              return (
                                <option value={item.academyTypeId}>
                                  {item.academyTypeName}
                                </option>
                              );
                            })}
                        </FormSelect>
                      </td>
                      <td>{item.latitude || "-"}</td>
                      <td>{item.longitude || "-"}</td>
                    </tr>
                ))}
              </tbody>

            ):(
              <tbody className="table-middle">
                <tr>
                  <td colSpan={6}> ไม่มีข้อมูล </td>
                </tr>
              </tbody>
            )}
            </table>
          </Col>
        </>
      )}

      {props.tableTabSettingId == 65 ? (
        props.type === "edit" ? (
          <Col md="12" style={{ padding: "15px" }}>
            <h5 style={{ float: "left" }}>
              จำนวนข้อมูลทั้งหมด {PowerbiData != null ? PowerbiData.length : 0}{" "}
              แถว เนื่องจากข้อมูลมีจำนวนมากจึงไม่สามารถแสดงได้
            </h5>
          </Col>
        ) : (
          <Col md="12" style={{ padding: "15px" }}>
            <h3>
              เนื่องจากชุดข้อมูล มีข้อมูลจำนวนมาก กรุณาเพิ่มข้อมูลต่างๆในรูปแบบ
              UPLOAD FILE
            </h3>
          </Col>
        )
      ) : null}

      {props.tableTabMaster ? null : props.type === "edit" && (
        <Col md="12" style={{ padding: "15px" }}>
          {props.status == 0 && props.userType != 3 ? (
            <>
            {importPath != null && (
              <a href={importPath} download >
                <Button theme="warning" style={{ float: "left" }}>
                  ดาวน์โหลดไฟล์ข้อมูลที่ใช้นำเข้า
                </Button>
              </a>
            )}

            <Button
              theme="success"
              onClick={() => props.onApproveTable()}
              style={{ float: "right", width: 200 }}
            >
              อนุมัติเผยแพร่
            </Button>
          </>
          ) : null}
        </Col>
      )}
    </Row>
  );
};

export default Table32;
